import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule} from "@angular/material/core";
import {MatButtonModule} from '@angular/material/button';
import {HttpClientModule} from "@angular/common/http";
import {MatCheckboxModule} from '@angular/material/checkbox'
import {MatChipsModule} from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from '@angular/material/select';
import { ChipsListComponent } from './chips-list/chips-list.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { DragAndDropDirective } from './drag-and-drop.directive';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatDialogModule} from '@angular/material/dialog';
import { DialogLoaderComponent } from './dialog-loader/dialog-loader.component';
import { InciDetailsComponent } from './inci-details/inci-details.component';
import { InciAlertsComponent } from './inci-alerts/inci-alerts.component';
import { ProductsDataComponent } from './products-data/products-data.component';
import { MatActionRowPersonnalisedComponent } from './mat-action-row-personnalised/mat-action-row-personnalised.component';
import { LoginComponent } from './login/login.component';
import { RecommendationsComponent } from './recommendations/recommendations.component';
import {MatTableModule} from '@angular/material/table';
import {MatCardModule} from '@angular/material/card';
import {MatPaginatorModule} from '@angular/material/paginator';


@NgModule({
  declarations: [
    AppComponent,
    ChipsListComponent,
    DragAndDropDirective,
    DialogLoaderComponent,
    InciDetailsComponent,
    InciAlertsComponent,
    ProductsDataComponent,
    MatActionRowPersonnalisedComponent,
    LoginComponent,
    RecommendationsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonModule,
    HttpClientModule,
    MatCheckboxModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatTableModule,
    MatCardModule,
    MatPaginatorModule
  ],
  providers: [ProductsDataComponent, ChipsListComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
